import axios from 'axios';
import store from '../store/store'

export default {
    async execute (method, resource, data) {
        await store.getters.getPropertyGuid
        await store.getters.getTenantGuid
        await store.getters.getJwtAuthenticationToken
        return axios({
            method,
            data,
            headers: {
                Authorization: store.getters.getJwtAuthenticationToken //the token is a variable which holds the token
            },
            url: "/residents/properties/" + store.getters.getPropertyGuid +
              "/units"+ resource,
        }).then(async req => {
            return req.data
        })
    },
    getUnit () {
        return this.execute('get', `` )
    },
    updateUnit (unitGuid, data) {
        return this.execute('put', '', data)
    },
    generateRandomPassphrase() {
        return Math.random().toString(36).substring(2,10);
    },

}
